import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { SearchIcon } from "../../../Resources/Icons/icons";
import { GetTDSReport } from "../../../Service/_index";
import { CSVLink } from "react-csv";
import SmartRangePicker from "../../../UiComponents/SmartRangePicker/SmartRangePicker";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import { Stack, Badge, Divider } from "@mui/material";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import dayjs from "dayjs";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import IconButton from "@mui/material/IconButton";
import FilterListIcon from "@mui/icons-material/FilterList";

const Month_headCells = [
  {
    id: "month",
    placeMent: true,
    disablePadding: false,
    label: "Month",
  },
  {
    id: "userName",
    placeMent: true,
    disablePadding: false,
    label: "Website Name",
  },
  {
    id: "branch",
    placeMent: true,
    disablePadding: false,
    label: "Branch",
  },
  {
    id: "bankAccountHolderName",
    placeMent: true,
    disablePadding: false,
    label: "Acc Holder Name",
  },
  {
    id: "panNumber",
    placeMent: true,
    disablePadding: false,
    label: "Pan Number",
  },
  {
    id: "amount",
    placeMent: true,
    disablePadding: false,
    label: "Amount",
  },
  {
    id: "TDS",
    placeMent: true,
    disablePadding: false,
    label: "TDS Percentage",
  },
  {
    id: "TDSamount",
    placeMent: true,
    disablePadding: false,
    label: "TDS Amount",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
];

const Date_headCells = [
  {
    id: "transactionDate",
    placeMent: true,
    disablePadding: false,
    label: "Transaction Date",
  },
  {
    id: "paymentDate",
    placeMent: true,
    disablePadding: false,
    label: "Payment Date",
  },
  {
    id: "userName",
    placeMent: true,
    disablePadding: false,
    label: "User Name",
  },
  {
    id: "branch",
    placeMent: true,
    disablePadding: false,
    label: "Branch",
  },
  {
    id: "amount",
    placeMent: true,
    disablePadding: false,
    label: "Amount",
  },
  {
    id: "bank",
    placeMent: true,
    disablePadding: false,
    label: "Bank",
  },
  {
    id: "remark",
    placeMent: true,
    disablePadding: false,
    label: "Remark",
  },
  {
    id: "payment",
    placeMent: true,
    disablePadding: false,
    label: "Payment",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
];

const TdsReport = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [data, setData] = React.useState([]);
  const [isMonth, setIsMonth] = useState(true);
  const [selectedDate, setSelectedDate] = useState();
  const [filterType, setFilterType] = useState("MONTH");
  const [tableConfig, setTableConfig] = useState({});
  const [allData, setAllData] = React.useState([]);
  const [filteredData, setFilteredData] = React.useState([]);
  const [dateRange, setDateRange] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const activeFiltersCount = dateRange?.[0] ? 1 : 0;

  const getTableData = (requestType, date = selectedDate) => {
    // Changes by Arun
    if (!date) {
      ToastError("Please select month");
      return true;
    }
    setFilterType(requestType);
    const formattedDate = date?.map((d) => dayjs(d).format("YYYY-MM-DD"));
    GetTDSReport(requestType, formattedDate).then((res) => {
      const data = res.data
        .map((e) => {
          return {
            ...e,
            paymentDate: e?.paymentDate
              ? moment(e.paymentDate).format("DD-MM-YYYY HH:mm:ss")
              : "N/A",
            transactionDate: e?.transactionDate
              ? moment(e.transactionDate).format("DD-MM-YYYY")
              : "N/A",
            actualBankDetail: e.bankDetails.find(
              (element) => element?.accountNumber == e.accountNumber
            ),
          };
        })
        .filter(Boolean);
      // console.log("table data ", data);
      setData(data);
      setAllData(data);
      setFilteredData(data);
    });
  };

  const onSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();

    if (!searchValue) {
      setFilteredData(allData);
      return;
    }

    const searchResults = allData.filter((el) =>
      `${el?.userName},${el?.branch},${el?.amount},${el?.TDSamount},${el?.company},${el?.actualBankDetail?.bankAccountHolderName},${el?.actualBankDetail?.panNumber},${el?.actualBankDetail?.bankName}`
        .toLowerCase()
        .includes(searchValue)
    );
    setFilteredData(searchResults);
    setPage(0);
  };

  const MonthOfFilterFunction = () => {
    setIsMonth(true);
    setPage(0);
  };

  const DateOfFilterFunction = () => {
    setIsMonth(false);
    setPage(0);
  };

  const header = [
    { label: "Transaction Date", key: "transactionDate" },
    { label: "Payment Date", key: "paymentDate" },
    { label: "User Name", key: "userName" },
    { label: "Account Name", key: "actualBankDetail.bankAccountHolderName" },
    { label: "PAN Number", key: "actualBankDetail.panNumber" },
    { label: "Branch", key: "branch" },
    { label: "Amount", key: "amount" },
    { label: "TDS %", key: "TDS" },
    { label: "TDS Amount", key: "TDSamount" },
    { label: "Payment", key: "payment" },
    { label: "Company", key: "company" },
  ];

  const headCells = [
    { label: "Transaction Date", id: "TransactionDate" },
    { label: "Payment Date", id: "PaymentDate" },
    { label: "User Name", id: "userName" },
    // { label: "Account Name", key: "actualBankDetail.bankAccountHolderName" },
    // { label: "PAN Number", key: "actualBankDetail.panNumber" },
    { label: "Branch", id: "branch" },
    { label: "Amount", id: "amount" },
    { label: "Bank", id: "bank" },
    { label: "Remark", id: "remark" },
    // { label: "TDS %", key: "TDS" },
    // { label: "TDS Amount", key: "TDSamount" },
    { label: "Payment", key: "payment" },
    { label: "CompanyName", id: "company" },
  ];

  const csvFile = {
    filename: "TDS Report Data",
    headers:
      filterType === "MONTH"
        ? header.filter(
          (item) =>
            item.key !== "TransactionDate" && item.key !== "PaymentDate"
        )
        : header,
    data: data,
  };

  const formattedData = filteredData.map((item) => ({
    ...item,
    panNumber: item.actualBankDetail?.panNumber || "N/A",
    bankAccountHolderName: item.actualBankDetail?.bankAccountHolderName,
    month: item.month
      ? dayjs(item.month).format("MMMM")
      : item.transactionDate && item.transactionDate !== "N/A"
        ? moment(item.transactionDate, "DD-MM-YYYY").format("MMMM")
        : "N/A",
    bank: item.actualBankDetail?.bankName,
  }));

  useEffect(() => {
    setSelectedDate(dateRange);
    if (dateRange && dateRange.length > 0) {
      getTableData(isMonth ? "MONTH" : "DATE", dateRange);
    } else {
      setData([]);
      setAllData([]);
      setFilteredData([]);
    }
  }, [dateRange, isMonth]);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
          <Grid container className="Master_Card_Container">
            <Grid
              container
              alignItems={"center"}
              className="Master_Card_Sub_Container"
              sx={{ mb: 2 }}
            >
              <Grid item xs={12} sm={6} md={4}>
                <Typography className="Master_Card_Tittle">
                  TDS Report
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={8}
                className="d-flex"
                justifyContent={{
                  xs: "start",
                  sm: "flex-end",
                  md: "flex-end",
                }}
              >
                <Stack
                  direction={{ xs: "column", sm: "row", md: "row" }}
                  spacing={2}
                  mt={{ xs: 2, sm: 2, md: 0 }}
                >
                  <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          color="error"
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button>
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      fullWidth
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                    >
                      <CSVLink
                        style={{ textDecoration: "none", color: "inherit" }}
                        {...csvFile}
                      >
                        Export
                      </CSVLink>
                    </Button>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>

            {showFilter && (
              <Box
                sx={{
                  mb: 2,
                  overflow: "visible",
                  position: "relative",
                  zIndex: 1200,
                  width: "100%",
                  p: 2,
                }}
              >
                <Grid
                  container
                  spacing={2}
                  alignItems="flex-end"
                  sx={{ mb: 2 }}
                >
                  <Grid item>
                    <Typography
                      variant="caption"
                      sx={{ color: "gray", display: "block", mb: 0.5 }}
                    >
                      Month & Year
                    </Typography>
                    <SmartRangePicker
                      picker="month"
                      value={dateRange}
                      onChange={(dates) => setDateRange(dates)}
                      style={{ height: "40px" }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={MonthOfFilterFunction}
                      sx={{
                        bgcolor: isMonth ? "#0047FF" : "#E0E0E0",
                        color: isMonth ? "white" : "black",
                        "&:hover": {
                          bgcolor: isMonth ? "#0037CC" : "#D0D0D0",
                        },
                        width: "120px",
                        height: "40px",
                        textTransform: "none",
                      }}
                    >
                      Month
                    </Button>
                    <Button
                      variant="contained"
                      onClick={DateOfFilterFunction}
                      sx={{
                        bgcolor: !isMonth ? "#0047FF" : "#E0E0E0",
                        color: !isMonth ? "white" : "black",
                        "&:hover": {
                          bgcolor: !isMonth ? "#0037CC" : "#D0D0D0",
                        },
                        width: "120px",
                        textTransform: "none",
                      }}
                    >
                      Date
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}

            <Grid item xs={12}>
              <Divider
                sx={{
                  backgroundColor: "#EAECF0",
                  borderWidth: 1,
                }}
              />
            </Grid>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"flex-end"}
              sx={{ margin: 1 }}
            >
              <Grid item xs={12} sm={4} md={3.1}>
                <Input
                  focused="false"
                  className="w-100 Master_Card_Input"
                  id="standard-adornment-password"
                  onChange={(e) => {
                    onSearch(e);
                  }}
                  disableUnderline={true}
                  placeholder="Search"
                  startAdornment={
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "0px" }}
                    >
                      <IconButton aria-label="toggle password visibility">
                        <SearchIcon
                          sx={{
                            fontSize: "20px",
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
            </Grid>
            <MasterCommonTable
              tableConfig={tableConfig}
              data={formattedData}
              columns={isMonth ? Month_headCells : Date_headCells}
            />
          </Grid>
        </Box>
      </Box>
    </>
  );
};
export default TdsReport;
